import { createDependencyInjectableComponent } from "@faire/retailer/app/_lib/dependencyInjectableComponent";
import { RouteQueryParamsProps } from "@faire/web/common/query-params/IQueryParamsProps";
import React, { Suspense, useEffect } from "react";

import { loadable } from "@faire/retailer/lib/loadable";
import { handleComponentLoadError } from "@faire/retailer/lib/loadChunkErrors";
import { ProductCacheStore } from "@faire/retailer/stores/domain/ProductCacheStore";
import { ProductLoadingSkeleton } from "@faire/retailer/views/product/__internal__/ProductLoadingSkeleton";

type IProps = RouteQueryParamsProps<"/product/productToken">;

export const LazyProductPage: React.FC<IProps> = (props) => {
  const ProductPage = useProductPage();
  const productToken = props.match.params.productToken;

  useEffect(() => {
    if (!productToken) {
      throw new Error("Missing productToken");
    }

    ProductCacheStore.get().fetchLeanProduct(productToken);
  }, [productToken]);

  return (
    <Suspense fallback={<ProductLoadingSkeleton />}>
      <ProductPage key={productToken} {...props} />
    </Suspense>
  );
};

export const LazyProduct = loadable(
  () =>
    import(/* webpackChunkName: "product-page" */ "./Product").catch(
      handleComponentLoadError
    ),
  { resolveComponent: (m) => m.Product }
);

const {
  useDependencyInjectableComponent: useProductPage,
  DependencyInjectableComponentProvider: ProductPageProvider,
} = createDependencyInjectableComponent(LazyProduct);

export { ProductPageProvider };
